import React from 'react'
import { useDispatch } from 'react-redux'
import { bindActionCreators } from 'redux'

import { loadPublishedPosts, loadPublishedResponses } from 'state/actions/posts'
import ProfileSummary from './ProfileSummary'
import ComingSoon from 'components/ComingSoon'
import TertiaryDivision from 'components/TertiaryDivision'
import LoadingLoadedOrExploded from 'components/LoadingLoadedOrExploded'

import Posts from './posts/Posts'
import BioPage from './BioPage'
import styles from './ProfilePage.css'
import { usePlaceType } from '../../navigation'
import {
  PageCssOverrides,
  ProfileBreadCrumbs,
  ProfilePageNavigation,
} from 'lib-core'
import { useProfileSearchAction } from './AsyncMyProfilePage'

const ProfilePage = ({
  isMine,
  profile,
  loading,
  error,
  figures = {},
  ProfileSummaryButton,
}) => {
  const { searchAction: onSearch } = useProfileSearchAction()
  const loaded = profile && {
    isMine,
    profile,
    ProfileSummaryButton,
    figures,
    onSearch,
  }

  return (
    <LoadingLoadedOrExploded
      error={error && error.message}
      loading={loading}
      loaded={loaded}
      loadedComponent={Profile}
    />
  )
}

const ProfilePosts = ({ isMine, profile }) => {
  const dispatch = useDispatch()

  const placeType = usePlaceType()
  const loadPosts =
    (placeType === PROFILE_POSTS &&
      bindActionCreators(loadPublishedPosts, dispatch)) ||
    bindActionCreators(loadPublishedResponses, dispatch)
  return <Posts isMine={isMine} author={profile} loadPosts={loadPosts} />
}

const ProfileBio = ({ profile }) => (
  <BioPage bio_display={profile.bio_display} bio={profile.bio} />
)
const MemberPosts = ({ isMine, profile }) => (
  <Posts isMine={isMine} author={profile} />
)

const PROFILE_POSTS = 'profile/public/posts'
const PROFILE_RESPONSES = 'profile/public/responses'
const PROFILE_BIO = 'profile/public/bio'
const PROFILE_EVENTS = 'profile/public/events'

const MEMBER_RESPONSES = 'home/member/responses'
const MEMBER_POSTS = 'home/member/posts'
const MEMBER_BIO = 'home/member/bio'
const MEMBER_EVENTS = 'home/member/events'

const ProfileTabs = ({ isMine, profile }) => {
  const placeType = usePlaceType()
  const tabsContentComponents = {
    [PROFILE_POSTS]: ProfilePosts,
    [PROFILE_EVENTS]: ProfilePosts,
    [PROFILE_RESPONSES]: ProfilePosts,
    [MEMBER_POSTS]: MemberPosts,
    [MEMBER_EVENTS]: MemberPosts,
    [MEMBER_RESPONSES]: MemberPosts,
    [MEMBER_BIO]: ProfileBio,
    [PROFILE_BIO]: ProfileBio
  }

  const TabsContentComponent = tabsContentComponents[placeType] || ComingSoon

  return (
    <TertiaryDivision>
      <TabsContentComponent isMine={isMine} profile={profile} />
    </TertiaryDivision>
  )
}

const Profile = ({ isMine, profile, ProfileSummaryButton, onSearch }) => {
  return (
    <div className='ns flex w-full flex-col gap-2 p-2'>
      <ProfilePageNavigation onSearch={onSearch} profile={profile}  isMine={isMine} />
      <ProfileBreadCrumbs isMine={isMine} />
      <PageCssOverrides />
      <ProfileSummary
        isMine={isMine}
        profile={profile}
        ProfileSummaryButton={ProfileSummaryButton}
      />
      <ProfileTabs isMine={isMine} profile={profile} />
    </div>
  )
}

export default ProfilePage
